/**
 * Analytics helper — Ri.Sco. s.r.l.
 *
 * - GA4 Measurement ID: G-DQYHC97PMR (definito in public/index.html)
 * - Consent Mode v2: gtag('consent', 'default', ...) è già impostato a "denied"
 *   nel <head>; qui esponiamo grantConsent()/revokeConsent() per il banner.
 * - Nessun tracking se:
 *     - hostname non è la produzione (esclude preview + localhost)
 *     - path inizia con /admin (dashboard riservata)
 *     - l'utente non ha (ancora) accettato i cookie analitici
 *
 * NOTE: non blocchiamo l'invio via `gtag`; la libreria di Google stessa
 * mantiene la coda e la scarta se il consenso resta denied — semplifichiamo
 * comunque lato client con un early return per l'admin/preview.
 */

export const GA_MEASUREMENT_ID = "G-DQYHC97PMR";

const PRODUCTION_HOSTS = ["riscocostruzioni.it", "www.riscocostruzioni.it"];

export function isProductionHost() {
  if (typeof window === "undefined") return false;
  return PRODUCTION_HOSTS.includes(window.location.hostname);
}

export function isAdminPath(pathname = window.location.pathname) {
  return pathname.startsWith("/admin");
}

function canTrack() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return false;
  if (!isProductionHost()) return false;
  if (isAdminPath()) return false;
  return true;
}

/** Chiamato dal CookieBanner quando l'utente accetta i cookie analitici. */
export function grantConsent() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    analytics_storage: "granted",
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
  });
}

/** Chiamato se l'utente rifiuta (o revoca) i cookie analitici. */
export function revokeConsent() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
}

/** Invia un evento personalizzato a GA4. Silenzioso in dev/admin. */
export function track(eventName, params = {}) {
  if (!canTrack()) return;
  window.gtag("event", eventName, params);
}

/** Invia un page_view manuale (SPA). Chiamato ad ogni cambio di route. */
export function trackPageView(pathname, title) {
  if (!canTrack()) return;
  window.gtag("event", "page_view", {
    page_path: pathname,
    page_location: window.location.href,
    page_title: title || document.title,
    send_to: GA_MEASUREMENT_ID,
  });
}
